import React from 'react';

/**
 * PDF 페이지 공통 래퍼 — 머릿말 + 본문 + 미주
 * 모든 PDF 페이지에서 동일한 레이아웃과 스타일 사용.
 *
 * Props:
 *   officeName  — 좌상단 중개사무소명
 *   pageLabel   — 우상단 영문 라벨 (Profile, Property Report, Land Information 등)
 *   dateLabel   — 미주 우측 날짜 (YYYY · MM)
 *   className   — 페이지 고유 클래스 (p02, p03, p04 등) — 내부 콘텐츠 스타일용
 *   children    — 본문 콘텐츠
 */
function PdfPage({ officeName, pageLabel, dateLabel, className, children }) {
  return (
    <div className={`pdf-page ${className || ''}`}>
      <div className="pdf-page__top">
        <span className="left">{officeName}</span>
        <span className="right">{pageLabel}</span>
      </div>
      <div className="pdf-page__body">
        {children}
      </div>
      <div className="pdf-page__bottom">
        <span>Property Report <span style={{ textTransform: 'none' }}>@ disco.re</span></span>
        <span className="num">{dateLabel}</span>
      </div>
    </div>
  );
}

export default PdfPage;
